import { Button, ButtonProps } from 'antd';
import { useState } from 'react';
import { createPortal } from 'react-dom';

import NurseStatePracticeAuthorizationsModal from './modal';

export default function NurseStatePracticeAuthorizationsButton(
    props: ButtonProps & {
        nurseProfileId: string;
    }
) {
    const [open, setOpen] = useState(false);

    const { nurseProfileId, ...buttonProps } = props;

    return (
        <>
            <Button {...buttonProps} onClick={() => setOpen(!open)} type="link">
                {props.children ?? 'View Authorized States'}
            </Button>
            {open &&
                createPortal(
                    <NurseStatePracticeAuthorizationsModal
                        nurseProfileId={nurseProfileId}
                        onClose={() => setOpen(false)}
                    />,
                    document.body
                )}
        </>
    );
}
